import React from 'react';
import { Asset, Box } from '@hz-design-system/web-ui';

import energyLabels from './energyLables.json';
import Classes from './ListingEnergyLabel.module.scss';

interface TenantContext {
  tenant: string;
  locale: string;
}

interface ListingEnergyLabelProps {
  rating: string;
  tenantContext: TenantContext;
  className?: string;
}

const ListingEnergyLabel: React.FC<ListingEnergyLabelProps> = ({
  rating,
  tenantContext: { tenant, locale },
  className,
}) => {
  const assetName = energyLabels[tenant][locale][rating];

  return (
    <Box as="div" name="Listing-EnergyLabel-wrapper" className={Classes['hz-Listing-EnergyLabel-wrapper']}>
      <Asset.Fluid name={assetName} className={`${Classes[`hz-EnergyLabel${tenant}`]} ${className || ''}`} />
    </Box>
  );
};

export default ListingEnergyLabel;
